/*
 * 还款提醒请求
 * */
import { collectionServiceClient } from "@/api/collectionServiceClient";
import { GetRemindCaseReq } from "@/pbjs/xcommon/collection_pb.js";
import InnerRequest from "./request";
// lin 获取工单分配支持的所有的参数数据
interface Options {
  caseId: number;
}
export function setGetRemindCaseReq(arg: Options) {
  let request: any = new GetRemindCaseReq();
  request.setCaseid(arg.caseId);
  return request;
}
export const getRemindCaseRequest = new InnerRequest(
  collectionServiceClient,
  collectionServiceClient.getRemindCase
);
